<template>
  <div>
    <div class="d-flex justify-end align-center pa-6">
      <v-spacer></v-spacer>
      <v-btn color="green" dark outlined @click="exportExcel">
        <v-icon left> mdi-file-excel-outline</v-icon>Xuất Excel
      </v-btn>
    </div>
    <v-data-table
      class="px-6"
      :headers="headers"
      :items="boardingClassSessions"
      item-key="id"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
    >
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          small
          style="margin: 0"
          class="white--text"
          v-if="item.status"
          :color="item.status | boardingClassSessionStatusColor"
          label
        >
          {{ item.status | boardingClassSessionStatusText }}
        </v-chip>
      </template>
      <template v-slot:[`item.uncheckNumber`]="{ item }">
        <div v-if="item.uncheckNumber > 0" style="color: red">{{ item.uncheckNumber }}</div>
        <div v-else>{{ item.uncheckNumber }}</div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn class="elevation-0" icon @click="viewDetail(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BoardingClassSession } from '@/plugins/api'
import utils from '@/plugins/utils'
import moment from 'moment'

const defaultHeaders = [
  {
    text: 'Ngày',
    value: 'date',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Sĩ số',
    value: 'totalCount',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Có mặt',
    value: 'attendanceCount',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Vắng mặt',
    value: 'absentCount',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Có phép',
    value: 'excusedAbsentCount',
    align: 'left',
    sortable: false,
    show: true,
  },
  {
    text: 'Không phép',
    value: 'unexcusedAbsentCount',
    align: 'left',
    sortable: false,
    show: true,
  },
  { text: 'Trạng thái', value: 'status', align: 'left', sortable: false, show: true },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'center',
    sortable: false,
    show: true,
  },
]
export default {
  components: {},
  props: {
    filters: Object,
    currClass: Object,
  },
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 5,
      },
      selectedboardingClassSession: null,
      addboardingClassSession: false,
      studentSearchParams: {},
      boardingClassSessions: [],
      classCount: 0,
      loading: false,
      dialog: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số lớp mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
      }
      return footerOptions
    },
  },
  methods: {
    async searchboardingClassSessionClass() {
      this.$loading.active = true
      this.loading = true
      if (this.filters) {
        this.tableOptions.page = 1
      }
      try {
        this.boardingClassSessions = await BoardingClassSession.getBoardingClassSessionByClass({
          ...this.filters,
          ...this.pageSetting(),
        })
        this.classCount = this.boardingClassSessions.length
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần lớp bán trú')
        console.error(error)
      }
      this.loading = false
      this.$loading.active = false
    },
    pageSetting() {
      return {}
    },
    openDialog(item) {
      this.selectedboardingClassSession = item
      this.$nextTick(() => {
        this.dialog = !this.dialog
      })
    },
    viewDetail(item) {
      const url = `/boarding-class-session/${item.class.id}`
      window.open(url, '_blank')
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = defaultHeaders
        const excelHeader = headers
          .map(({ text, value }) => ({ text, value }))
          .filter(excel => excel.value !== 'action')
        const list = this.boardingClassSessions
        const data = JSON.parse(JSON.stringify(list))
        const startDate = moment(this.filters.date_gte).utcOffset(7).format('DD/MM/YYYY')
        const endDate = moment(this.filters.date_gte).utcOffset(7).format('DD/MM/YYYY')
        utils.exportExcel(
          data,
          excelHeader,
          `${this.currClass ? this.currClass.title : ''}-${startDate}-${endDate}_ChuyenCan`
        )
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {},
}
</script>
